import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './Gallery.css';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState('All');

  // Gallery images with categories - NOW WITH ALL 18 IMAGES
  const images = [
    { id: 1, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/fdvfy0n5_Screenshot%202025-10-12%20220615.png', category: 'Haldi', alt: 'Golden Gazebo Haldi Setup' },
    { id: 2, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/s95edowc_Screenshot%202025-10-12%20220654.png', category: 'Mehndi', alt: 'Red Sofa Colorful Backdrop' },
    { id: 3, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/8xltqro8_Screenshot%202025-10-12%20220713.png', category: 'Haldi', alt: 'Orange Pink Marigold Cascade' },
    { id: 4, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/obwh9pzr_Screenshot%202025-10-12%20220813.png', category: 'Haldi', alt: 'Yellow Spectacles Iconic Setup' },
    { id: 5, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/c1mr0m0f_Screenshot%202025-10-12%20220826.png', category: 'Mehndi', alt: 'Yellow Windmill Decor' },
    { id: 6, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/j8ycg17v_Screenshot%202025-10-12%20220639.png', category: 'Mehndi', alt: 'Vibrant Floral Mehndi Setup' },
    { id: 7, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/4sn3e26g_image.png', category: 'Haldi', alt: 'Vibrant Haldi Stage Setup' },
    { id: 8, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/1y6plkef_image.png', category: 'Haldi', alt: 'Yellow Spectacles Haldi Decor' },
    { id: 9, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/m6gqy56x_image.png', category: 'Poolside', alt: 'Daytime Poolside Setup' },
    { id: 10, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/l37pzpku_image.png', category: 'Poolside', alt: 'Yellow Drapes Pool Area' },
    { id: 11, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/2gjfz72w_image.png', category: 'Lawn', alt: 'Wide Venue View with Pink Sofas' },
    { id: 12, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/wdfs2fgr_IMG-20251012-WA0022.jpg', category: 'Haldi', alt: 'Haldi Ceremony Setup' },
    { id: 13, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/z5ncmykk_IMG-20251012-WA0018.jpg', category: 'Haldi', alt: 'Poolside Haldi Evening' },
    { id: 14, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/j6o6ntwb_IMG-20251012-WA0021.jpg', category: 'Night', alt: 'Night Illumination' },
    { id: 15, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/it86ckwb_IMG-20251012-WA0014.jpg', category: 'Night', alt: 'Night Ambience' },
    { id: 16, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/4syl1sjz_IMG-20251012-WA0013.jpg', category: 'Poolside', alt: 'Evening Poolside' },
    { id: 17, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/d3zrqpid_IMG-20251012-WA0015.jpg', category: 'Night', alt: 'Illuminated Entrance' },
    { id: 18, src: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/p089jiws_IMG-20251012-WA0011.jpg', category: 'Entrance', alt: 'Grand Entrance at Night' }
  ];

  const filters = ['All', 'Lawn', 'Haldi', 'Mehndi', 'Poolside', 'Night', 'Entrance'];

  const filteredImages = selectedFilter === 'All' 
    ? images 
    : images.filter(img => img.category === selectedFilter);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction) => {
    const currentIndex = images.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % images.length;
    } else {
      newIndex = (currentIndex - 1 + images.length) % images.length;
    }
    
    setSelectedImage(images[newIndex]);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <span className="section-subtitle text-gold">Memories</span>
          <h1 className="hero-medium">Our Gallery</h1>
          <p className="body-large mt-24">
            Explore the beauty and elegance of The Green Valley through our curated collection of moments – {images.length} stunning images showcasing our vibrant setups
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="gallery-filters">
            {filters.map((filter) => (
              <button
                key={filter}
                className={`filter-button ${selectedFilter === filter ? 'active' : ''}`}
                onClick={() => setSelectedFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          <div className="gallery-grid">
            {filteredImages.map((image) => (
              <div 
                key={image.id} 
                className="gallery-item"
                onClick={() => openLightbox(image)}
              >
                <img src={image.src} alt={image.alt} className="gallery-image" />
                <div className="gallery-overlay">
                  <span className="gallery-category">{image.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close">
            <X size={32} />
          </button>
          <button 
            className="lightbox-nav lightbox-prev" 
            onClick={(e) => { e.stopPropagation(); navigateImage('prev'); }}
            aria-label="Previous image"
          >
            <ChevronLeft size={32} />
          </button>
          <button 
            className="lightbox-nav lightbox-next" 
            onClick={(e) => { e.stopPropagation(); navigateImage('next'); }}
            aria-label="Next image"
          >
            <ChevronRight size={32} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.alt} className="lightbox-image" />
            <p className="lightbox-caption">{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
